import { Icon } from '@amzn/meridian';
import sparklesSmallTokens from '@amzn/meridian-tokens/base/icon/sparkles-small';
import type { FC } from 'react';
import { stylesheet } from 'typestyle';

const css = stylesheet({
  iconLabel: {
    marginLeft: '0.25rem',
  },
});

// A small reusable component that renders the sparkles icon alongside a text label
export const SparkleIconWithLabel: FC<{
  label: string;
}> = ({ label }) => (
  <>
    <Icon aria-hidden="true" tokens={sparklesSmallTokens} />
    <span className={css.iconLabel}>{label}</span>
  </>
);
